import { useNoteName } from "../../../Project/ProjectStore"
import { Music } from "../../../Util/Music/Music"

export class PositionGroups{
    static Groups:number[][] = [[1],[2],[1,2],[3],[4],[3,4],[5],[6],[5,6]]
    static Labels:string[] = ['2nd', '3rd', '2nd & 3rd', '4th','5th','4th & 5th', '6th','7th','6th & 7th']
}
export function PositionSelectors(props:{onPositionClick:Function, selectedPositionIndexes:number[]}){
    const positionButtons:JSX.Element[] = []
    PositionGroups.Groups.forEach((positionGroup:number[], index:number)=>{
        const isSelected:boolean = props.selectedPositionIndexes.includes(index)
        positionButtons.push(<PositionButton isSelected={isSelected} onClick={props.onPositionClick} index={index} key={index}/>)
    })
    return <div className='key-selectors'>{positionButtons}</div>
}
export function PositionButton(props:{onClick:Function, index:number, isSelected:boolean}){
    const onClick = () => {props.onClick(props.index)}
    const label:string = PositionGroups.Labels[props.index]
    const getClassNames = () => {
        const classNames:string[] = ['position-button']
        if(props.isSelected){ classNames.push('selected')}
        return classNames.join(' ')
    }
    return <button type='button' className={getClassNames()} onClick={onClick}>{label}</button>
}

export function KeySelectors(props:{update:number, onKeyClick:Function, currentKeyTonic?:number, selectedKeys:number[], message?:string}){
    const keyButtons:JSX.Element[] = []
    const keyTonics:number[] = [Music.F,Music.C,Music.G,Music.D,Music.A,Music.E,Music.B,
                                Music.Gb,Music.Db,Music.Ab,Music.Eb,Music.Bb]
    keyTonics.forEach((tonic:number)=>{
        const isSelected:boolean = props.selectedKeys.includes(tonic)
        const isHilited:boolean = (props.currentKeyTonic === tonic)
        keyButtons.push(<KeyButton isHilited={isHilited} isSelected={isSelected} onClick={props.onKeyClick} keyTonic={tonic} key={tonic}/>)
    })
    return <div className={'key-selectors ' + props.update}>Keys:{keyButtons}</div>
}
export function KeyButton(props:{onClick:Function, keyTonic:number, isHilited:boolean, isSelected:boolean}){
    const onClick = () => {
        props.onClick(props.keyTonic)
    }
    const keyName:string = useNoteName(props.keyTonic)
    const getClassNames = () => {
        const classNames:string[] = ['key-button']
        if(props.isSelected){ classNames.push('selected')}
        if(props.isHilited){ classNames.push('hilited')}
        return classNames.join(' ')
    }
    return <button type='button' className={getClassNames()} onClick={onClick}>{keyName}</button>
}